import React from "react";
import { connect } from "react-redux";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { DoneAll, Print, Replay } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import MainNavbar from "../../components/Navbars/MainNavbar";
import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import * as actions from "../../store/actions";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";
import { toast } from "react-toastify";
import { format, parse } from "date-fns";

class Index extends React.Component {
  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.refreshData();
  };

  handleCustomDate = (item) => {
    if (item === null) {
      return null;
    }

    return format(parse(item, "yyyy-MM-dd HH:mm:ss", new Date()), "HH:mm:ss dd-MM-yy");
  };

  handleCustomDelay = (row) => {
    let printDateUx = Math.floor(new Date(row.printDate).getTime() / 1000);
    let printStartUx = Math.floor(new Date(row.updated_at).getTime() / 1000);
    if (row?.broadCastTime != null) {
      printStartUx = Math.floor(new Date(row.broadCastTime).getTime() / 1000);
    }
    return printDateUx - printStartUx;
  };

  handleDelay = (item) => {
    if (item > 0) {
      return item + " s";
    } else {
      return "";
    }
  };

  handleStatus = (item) => {
    let returnValue = "";

    if (item == 1) {
      returnValue = <Print style={{ color: "ORANGE" }} />;
    }

    if (item == 3) {
      returnValue = <DoneAll style={{ color: "GREEN" }} />;
    }

    return returnValue;
  };

  handleZAfslag = (item) => {
    let returnValue = "";

    if (item == 1) {
      returnValue = <DoneAll style={{ color: "GREEN" }} />;
    }

    return returnValue;
  };

  handleReprintAction = (row) => {
    let data = {
      queue_ids: [row[0]],
    };

    axios
      .post("/core/printerqueue/reprint", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
        } else {
          toast.error(response.data.data.message);
        }

        setTimeout(() => {
          this.refreshJamezzTable();
        }, 10000);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error("Oeps er is iets mis gegaan!");
        }
      });
  };

  render() {
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Printer queue"} tKey={"printerqueue.pagetitle"} />} />

        <GridContainer>
          <VestigingenFilter />
          <GridItem md={4} xs={12}>
            <TextFilter
              field={"bestelling_id"}
              fieldKey={"printerqueue:bestelling_id"}
              placeholder={getTranslation("printerqueue.filter.orderid", "Bestel nummer")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Replay,
                  tooltip: (
                    <TranslationWrapper tDefault={"Print opnieuw"} tKey={"printerqueue.table.tooltip.reprint"} />
                  ),
                  action: this.handleReprintAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "status", customRender: this.handleStatus },
                { dbfield: "zafslag", customRender: this.handleZAfslag },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { dbfield: "printer.name", editable: false },
                { dbfield: "tafel.naam", editable: false },
                { dbfield: "bestelling_id", editable: false },
                { customData: this.handleCustomDelay, customRender: this.handleDelay },
                { dbfield: "printStart", customRender: this.handleCustomDate },
                { dbfield: "broadCastTime", customRender: this.handleCustomDate },
                { dbfield: "jobFetchTime", customRender: this.handleCustomDate },
                { dbfield: "printDate", customRender: this.handleCustomDate },
              ]}
              dbfields={
                "id,status,zafslag,printStart,printDate,updated_at,vestiging_id,broadCastTime,jobFetchTime,vestiging.id,vestiging.systeemNaam,bestelling_id,table_id,tafel.id,tafel.naam,printer_id,printer.id,printer.name"
              }
              fetchUrl={"core/printerqueue"}
              filters={this.props.filters}
              headerIcon={<Print />}
              headers={[
                {
                  label: getTranslation("printerqueue.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("printerqueue.table.status", "Status"),
                  sortable: false,
                },
                {
                  label: getTranslation("printerqueue.table.zafslag", "Z-Afslag"),
                  sortable: false,
                },
                {
                  label: getTranslation("printerqueue.table.vestiging", "Vestiging"),
                  sortable: false,
                  sortKey: "vestiging.systeemNaam",
                },
                {
                  label: getTranslation("printerqueue.table.printer", "Printer"),
                  sortable: false,
                  sortKey: "printer.name",
                },
                {
                  label: getTranslation("printerqueue.table.table", "Tafel"),
                  sortable: false,
                  sortKey: "tafel.naam",
                },
                {
                  label: getTranslation("printerqueue.table.bestelling_id", "Bestel nummer"),
                  sortable: true,
                  sortKey: "bestelling_id",
                },
                {
                  label: getTranslation("printerqueue.table.delay", "Delay"),
                  sortable: false,
                },
                {
                  label: getTranslation("printerqueue.table.printStart", "Start time"),
                  sortable: true,
                  sortKey: "printStart",
                },
                {
                  label: getTranslation("printerqueue.table.1stbroadcasttime", "1st broadcast time"),
                  sortable: true,
                  sortKey: "broadCastTime",
                },
                {
                  label: getTranslation("printerqueue.table.fetDate", "Fetch time"),
                  sortable: true,
                  sortKey: "jobFetchTime",
                },
                {
                  label: getTranslation("printerqueue.table.printDate", "Finish time"),
                  sortable: true,
                  sortKey: "printDate",
                },
              ]}
              reduxKey={"printerqueue"}
              ref={this.jamezzTable}
              showAutoRenew
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Printer queue"} tKey={"printerqueue.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["printerqueue:bestelling_id"]) {
    filters["printerqueue:bestelling_id"] = state.filtersV2["printerqueue:bestelling_id"];
  }
  return {
    filters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
